import React, { useState, useEffect, Fragment } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import './Notes.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate'
import DateTime from '../../../../components/library/common/DateTime'
import DOMPurify from 'dompurify'
import Skeleton from '../../../../components/library/loaders/Skeleton'
import noteService from '../../services/notes/NoteService'


const Note = props => {
    const { note, loaded} = props

    const [loadingUserName, setLoadingUserName] = useState(true)
    const [userName, setUserName] = useState('')


    const getNoteAuthorInfo = async () => {
        if (userName === '' && note) {
            // get the user name
            let response = await noteService.getNoteAuthor(note.lastModifiedBy)
            if (response && response.data) {
                // add sent message to our list and increase our offset value for the next getMessages call.
                setUserName(response.data.firstName + ' ' + response.data.lastName)
                setLoadingUserName(false)
            }
        }
    }

    useEffect(() => {
        getNoteAuthorInfo()
    }, [])

    return (
        <div className='note-container columns'>
            {loaded &&
                <Fragment>
                <div id={`note-content-${note.id}`} className={classnames('column is-offset-1 is-6')}>
                    <div className='note note-content' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.messageText) }} />
                </div>            
                <div id={`note-date-${note.id}`} className={classnames('column is-5')}>
                    <div className='mb-1'>
                        <span className='pro-align note note-content'>
                        <HrbTranslate text='Messages.SentBy' params={
                                {
                                date: <DateTime value={note.lastModified || note.createdDate} dateAndTime compact />,
                                name: loadingUserName ? <Skeleton width={80} /> : userName
                                }} />
                        </span>
                    </div>                   
                </div>
                </Fragment>
            }            
        </div>)
}

Note.propTypes = {
    key: PropTypes.string,
    loaded: PropTypes.bool,
    senderName: PropTypes.string,
    isClientMessage: PropTypes.bool
}

export default Note